export default __webpack_public_path__ + "static/media/harstad.95887d69.webp";